import type { Components, Theme } from "@mui/material/styles";

export const MuiTableHead: Components<Theme>["MuiTableHead"] = {
  styleOverrides: {
    root: {
      fontSize: "0.875rem",
      fontWeight: 700,
    },
  },
};
